import {
    DELETEGATEWAYMAPPING_SUCCESS,
    DELETEGATEWAYMAPPING_FAILED,
    RESET_DELETEGATEWAYMAPPING,
    LOADING_DELETEGATEWAYMAPPING,
    NETWORK_ERROR_DELETEGATEWAYMAPPING,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DELETEGATEWAYMAPPING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case DELETEGATEWAYMAPPING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case DELETEGATEWAYMAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_DELETEGATEWAYMAPPING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_DELETEGATEWAYMAPPING:
            return (state = initialState);
        default:
            return state;
    }
};
